import React, { useEffect, useState, FC } from 'react';
import { gql, useQuery, useMutation, NetworkStatus } from '@apollo/client';
import Toolbar from '@mui/material/Toolbar';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import MDButtonRoot from "./MDButton/MDButtonRoot";
import setThemeObj from './../hooks/useThemeMUI';
import MDBoxRoot from './MDBox/MDBoxRoot';
import MDInput from './MDInput/MDInputRoot';
import StyledBox from "./StyleBox";
import { useNavigate, useParams } from 'react-router-dom';

import { formatStudent } from '../utils/studentUtils';

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { DataGrid, GridColDef, GridActionsCellItem, GridRowId } from '@mui/x-data-grid';
import { useScreenSize } from "../hooks/ScreenSizeContext";
import MDTypographyRoot from './MDTypography/MDTypographyRoot';

//import supabase, { supabaseKey, supabaseUrl } from '../supabase';
//import { graphql } from '../gql/gql';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';



// TODO: Make experience level configurable (in future allow adding arbitrary new arguments)
const getStudentsQuery = gql(`
  query GetStudents($after: Cursor, $first: Int!, $filter: fs_studentsFilter) {
    fs_studentsCollection(after: $after, first: $first, filter: $filter) {
        edges {
          node {
            nodeId
            id
            FirstName
            LastName
            Email
            DOB
            Height
            Weight
            AddrStreet
            AddrTown
            AddrZip
            AddrState
            Mobile
            EnrolementDate
            MedCondFlag
            MedCondDescr
            ExpLevel
            HasEquipment
            Notes
            RegisteredBy
          }
        }
        pageInfo {
            endCursor
            hasNextPage
        }
      }
  }
`);

const deleteStudentQuery = gql(`
    mutation deleteStudentQuery($filter:fs_studentsFilter) {
        deleteFromfs_studentsCollection(filter: $filter) {
            affectedCount
        }
    }
`);
const getPurchasesForStudentQuery = gql(`
    query GetPurchasesForStudent($id: BigInt!) {
        get_purchase_count_for_student(student_id:$id)
  }
`)


function StudentsList() {

    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [editedRow, setEditedRow] = useState(null);

    const [students, setStudents] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [endCursor, setEndCursor] = useState(null);
    const [rowCount, setRowCount] = useState(-1);
    const [FNFilter, setFNFilter] = useState('');
    const [LNFilter, setLNFilter] = useState('');
    const [EMFilter, setEMFilter] = useState('');
    const [paginationMeta, setPaginationMeta] = useState({ hasNextPage: true });
    const isSmallScreen = useScreenSize();

    const { loading, networkStatus, error, data, refetch } = useQuery(getStudentsQuery, {
        variables: {
            after: null,
            first: pageSize,
            // filter: {
            //     FirstName: { ilike: `%${FNFilter}%` },
            //     LastName: { ilike: `%${LNFilter}%` },
            //     Email: { ilike: `%${EMFilter}%` }
            // }
        },
        notifyOnNetworkStatusChange: true, // Needed to refresh 'data' after refetch
        fetchPolicy: 'no-cache',
    });

    const stat = networkStatus;

    const navigate = useNavigate();

    useEffect(() => {
        if (data) {
            const next = data.fs_studentsCollection.edges.map(st => formatStudent(st));
            const newStudents = [...students, ...next];
            const a = stat;
            //const newStudents = next;
            setStudents(newStudents);
            setEndCursor(data.fs_studentsCollection.pageInfo.endCursor);
            //setPageData(newStudents.slice(page * pageSize, (page + 1) * pageSize));
            if (!data.fs_studentsCollection.pageInfo.hasNextPage) {
                setRowCount(newStudents.length);
                setPaginationMeta({ hasNextPage: false });
            }
        }
    }, [data]);

    interface EditToolbarProps {
        openModal: () => void;
    }

    const handleClick = () => {
        navigate("../students/new");
    };

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 70 },
        {
            field: 'FirstName',
            headerName: 'First Name',
            width: 150,
            renderCell: (params) => (
                <span
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                    onClick={handleEditClick(params.row)}
                >
                    {params.value}
                </span>
            ),
        },
        {
            field: 'LastName',
            headerName: 'Last Name',
            width: 150,
            renderCell: (params) => (
                <span
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                    onClick={handleEditClick(params.row)}
                >
                    {params.value}
                </span>
            ),
        },
        {
            field: 'Mobile',
            headerName: 'Mobile',
            width: 150,
            renderCell: (params) => (
                <a href={`tel:${params.value}`} style={{ color: "blue", textDecoration: "underline" }}>
                    {params.value}
                </a>
            )
        },
        { field: 'Email', headerName: 'Email', width: 250 },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: (params) => {

                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary icons-style"
                        onClick={handleEditClick(params.row)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        className="textPrimary icons-style"
                        onClick={handleDeleteClick(params.row)}
                        color="inherit"
                    />,
                ];
            }
        },
    ];



    type FilterType = {
        FirstName?: { ilike: string };
        LastName?: { ilike: string };
        Email?: { ilike: string };
    };

    const handleSearchChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        let shouldRefetch = true;
        var FNf = FNFilter;
        var LNf = LNFilter;
        var EMf = EMFilter;

        switch (field) {
            case "FirstName":
                setFNFilter(value);
                if (value.length < 3 && FNFilter.length < 3) shouldRefetch = false;
                FNf = value;
                break;
            case "LastName":
                setLNFilter(value);
                if (value.length < 3 && LNFilter.length < 3) shouldRefetch = false;
                LNf = value;
                break;
            case "Email":
                setEMFilter(value);
                if (value.length < 3 && EMFilter.length < 3) shouldRefetch = false;
                EMf = value;
                break;
        }

        if (!shouldRefetch) return;

        const filter: {
            FirstName?: { ilike: string };
            LastName?: { ilike: string };
            Email?: { ilike: string };
        } = {};

        if (FNf.length >= 3) filter.FirstName = { ilike: `%${FNf}%` };
        if (LNf.length >= 3) filter.LastName = { ilike: `%${LNf}%` };
        if (EMf.length >= 3) filter.Email = { ilike: `%${EMf}%` };

        // Reset page and fetch only if valid input
        setPage(0);
        setStudents([]);
        setRowCount(-1);

        refetch({
            after: null,
            first: pageSize,
            filter
        });
    };

    const handlePaginationModelChange = (model) => {
        var newPage = model.page;
        var newPageSize = model.pageSize;

        if (newPageSize !== pageSize) {
            // Recalculate new page
            //newPage = Math.trunc((page * pageSize)/newPageSize);
            newPage = 0;
            setStudents([]);
        }

        // Requested range start
        const reqStart = newPage * newPageSize;

        // Need to fetch more
        if ((reqStart + newPageSize) > students.length) {
            if (data.fs_studentsCollection.pageInfo.hasNextPage) {
                const filter: {
                    FirstName?: { ilike: string };
                    LastName?: { ilike: string };
                    Email?: { ilike: string };
                } = {};

                if (FNFilter.length >= 3) filter.FirstName = { ilike: `%${FNFilter}%` };
                if (LNFilter.length >= 3) filter.LastName = { ilike: `%${LNFilter}%` };
                if (EMFilter.length >= 3) filter.Email = { ilike: `%${EMFilter}%` };

                refetch({
                    after: endCursor,
                    first: newPageSize,
                    ...(Object.keys(filter).length > 0 && { filter })
                });
            }
        }

        if (newPage !== page) setPage(newPage);
        if (newPageSize !== pageSize) setPageSize(newPageSize);
    };

    const handleEditClick = (row: any) => () => {
        navigate("../students/" + row.id);
    };

    const [deleteStudentMutation, { data: del_data, loading: del_loading, error: del_error }] = useMutation(deleteStudentQuery, {
        refetchQueries: [
            //'GetStudents' // Query name 
        ],
    });

    //if (loading) return (<div>Loading</div>)
    if (error) return (<div>Error</div>)

    const handleDeleteClick = (row: any) => async () => {
        setEditedRow(row);
        setIsDeleteDialogOpen(true);
    };

    const resetPage = async () => {
        setPage(0);
        setStudents([]);
        setRowCount(-1);

        const filter: {
            FirstName?: { ilike: string };
            LastName?: { ilike: string };
            Email?: { ilike: string };
        } = {};

        if (FNFilter.length >= 3) filter.FirstName = { ilike: `%${FNFilter}%` };
        if (LNFilter.length >= 3) filter.LastName = { ilike: `%${LNFilter}%` };
        if (EMFilter.length >= 3) filter.Email = { ilike: `%${EMFilter}%` };

        refetch({
            after: null,
            first: pageSize,
            filter
        });
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={11}>
                <Card>
                    <Toolbar />
                    <Card
                        sx={{
                            ...(isSmallScreen ? { paddingTop: "50px" } : { paddingTop: "60px" }),
                            width: '100%'
                        }}>

                        <MDBoxRoot ownerState={{
                            variant: "contained",
                            bgColor: "secondary",
                            coloredShadow: "secondary",
                        }}
                            borderRadius={2}
                            sx={{
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'center',
                                flexDirection: 'row',
                                alignItems: 'baseline'
                            }}>
                            {isSmallScreen ? '' : (
                                <MDTypographyRoot variant="h3" ownerState={{ color: "white" }}>
                                    <SearchIcon sx={{ verticalAlign: 'middle', fontSize: '30px' }} />  Filters :
                                </MDTypographyRoot>)}
                            <MDInput
                                label="First Name"
                                variant="outlined"
                                size="small"
                                value={FNFilter}
                                onChange={handleSearchChange("FirstName")}
                                ownerState={{
                                    labelColor: "white",
                                }}
                                style={{ marginRight: '10px' }}
                            />
                            <MDInput
                                label="Last Name"
                                variant="outlined"
                                size="small"
                                value={LNFilter}
                                onChange={handleSearchChange("LastName")}
                                ownerState={{
                                    labelColor: "white",
                                }}
                                style={{ marginRight: '10px' }}
                            />
                            <MDInput
                                label="Email"
                                variant="outlined"
                                size="small"
                                value={EMFilter}
                                ownerState={{
                                    labelColor: "white",
                                }}
                                style={{ marginRight: '10px' }}
                                onChange={handleSearchChange("Email")}
                            /></MDBoxRoot>
                    </Card>
                    <MDBoxRoot
                        component="main" px={4} py={4}
                        sx={{ flexGrow: 1, width: '100%' }}
                    >
                        <StyledBox theme={setThemeObj} >
                            <MDButtonRoot
                                ownerState={{
                                    size: "medium",
                                    variant: "text",
                                    color: "info",
                                    textTransform: "uppercase",
                                }}
                                onClick={handleClick} startIcon={<AddIcon />}
                            > Add student</MDButtonRoot>
                            <DataGrid
                                rows={students.slice(page * pageSize, page * pageSize + pageSize)}
                                columns={columns}
                                getRowId={(row) => row.id}
                                pagination
                                paginationMode="server"
                                paginationMeta={paginationMeta}
                                initialState={{ pagination: { rowCount: -1 } }}
                                rowCount={rowCount}
                                paginationModel={{ page, pageSize }}
                                onPaginationModelChange={handlePaginationModelChange}
                                pageSizeOptions={[100]}
                                disableRowSelectionOnClick={true} // Ensure this is not true
                                disableColumnMenu={true} 
                            />
                            {isDeleteDialogOpen && (<DeleteStudentDialog rowData={editedRow} onClose={() => setIsDeleteDialogOpen(false)} resetPage={resetPage}/>)}
                        </StyledBox>
                    </MDBoxRoot>
                </Card></Grid></Grid>

    )
}
export default StudentsList;

interface DeleteStudentDialogProps {
    rowData: any;
    onClose: () => void;
    resetPage: () => void;
}
const DeleteStudentDialog: FC<DeleteStudentDialogProps> = ({ rowData, onClose, resetPage }) => {

    const { loading, data: st_purchase_data } = useQuery(getPurchasesForStudentQuery, { variables: { id: rowData.id }, fetchPolicy: 'network-only' });
    const [deleteStudentMutation, { data: del_data, loading: del_loading, error: del_error }] = useMutation(deleteStudentQuery, {
        refetchQueries: [
        ],
    });

    const linkedPurchasesCount = st_purchase_data?.get_purchase_count_for_student;

    const handleDeleteStudent = async () => {
        const id = rowData.id;
        await deleteStudentMutation({ variables: { filter: { id: { eq: id } } } })
        resetPage();
        onClose();
    };


    return (
        <Dialog
            maxWidth="sm"
            open={!loading}
            fullWidth
        >
            <MDTypographyRoot variant="h5" px={1} py={1}>Delete student record? <CloseIcon onClick={onClose} sx={{ position: "absolute", top: "10px", right: "10px" }} /></MDTypographyRoot>
            <DialogContent dividers>
                <MDTypographyRoot variant="h4" px={1} ownerState={{ color: "dark" }}>
                    {linkedPurchasesCount === '0' && `Deleting student record for "${rowData.FirstName} ${rowData.LastName}"`}
                    {linkedPurchasesCount !== '0' && `Student "${rowData.FirstName} ${rowData.LastName}" has ${linkedPurchasesCount} linked purchases. Delete purchases before deleting the student.`}
                </MDTypographyRoot>
            </DialogContent>
            <DialogActions>
                {linkedPurchasesCount === '0' && (
                    <MDButtonRoot
                        ownerState={{
                            variant: "gradient",
                            color: "info",
                            textTransform: "none",
                            circular: false,
                            iconOnly: false,
                            darkMode: false
                        }}
                        size="medium"
                        onClick={handleDeleteStudent}
                        type="submit">
                        Delete
                    </MDButtonRoot>
                )}
                <MDButtonRoot
                    size="medium"
                    onClick={onClose}
                    ownerState={{
                        textTransform: "none",
                        variant: "gradient",
                        color: "warning",
                    }}>
                    Cancel
                </MDButtonRoot>
            </DialogActions>
        </Dialog>);
}
